module.exports = __webpack_public_path__ + "img/05.b2868a71.png";